export default {
  listRegistrationsTypes: [],
  registrationType: {
    nome: '',
    valor: '',
    ativo: true,
    tipo: null,
    tipoFaixaPadrao: null,
    tipoPagamentoPadrao: null,
    contaPadrao: null,
  },
  comboTypes: [],
  comboTipoFaixa: [],
  comboTipoPagamento: [],
  comboContas: [],
}
